module.exports = {"350128001":"海坛街道","350128107":"金井镇","350128108":"君山镇","350128109":"苏平镇","350128201":"屿头乡","350128205":"东庠乡","350128207":"南海乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350128.json
// module id = 1280
// module chunks = 0